export default __webpack_public_path__ + "static/media/date-field-trigger.765cabae.svg";